<template>
  <div class="content">
    <div class="center">
      <div class="header">
        <span>{{info.serviceType == 0 ? "成套设备合并订单" : "保电设备合并订单" }}</span>
        <el-button size="medium" type="warning" @click="customerServer">联系客服</el-button>
      </div>
      <div class="detail-box" v-for="(item, index) in eqList" :key="index">
        <div class="device-box flex-row">
          <div class="device-img">
            <img :src="$imgUrl + item.pictureUrl" />
          </div>
          <div class="device-info">
            <p class="name">{{ item.title }}</p>
            <div class="price-box flex-row">
              <span>价格</span>
              <span class="price" v-if="info.serviceType == 0"
                >￥{{ item.priceGears && item.priceGears.price }}/3月</span
              >
              <span class="price" v-else>￥{{ item.emergencyPrice }}/天</span>
            </div>
            <p class="tips">
              *价格说明<br />
              以上价格标注为参考价，具体价格您根据需求下单后待双方协商
            </p>
          </div>
          <div class="info">
            <div class="title">
              <p>设备信息</p>
            </div>
            <div class="info-intro">
              <div class="item">
                <label>提供人姓名</label>
                <span>{{
                  info.serviceType == 0 ? item.userName : item.companyName
                }}</span>
              </div>
              <div class="item">
                <label>设备类型</label> <span>{{ item.typeName }}</span>
              </div>
              <div class="item">
                <label>设备容量</label> <span>{{ item.volume }}</span>
              </div>
              <div class="item">
                <label>设备地点</label>
                <span>{{
                  item.provinceName + item.cityName + item.countyName
                }}</span>
              </div>
              <div class="item">
                <label>输出电压</label> <span>{{ item.voltage }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="intro-box" v-if="info.serviceType == 0">
          <div class="title">配套线路：</div>
          <div class="service-plan flex-row">
            <div class="item">
              <label>架空线路：</label>
              <span>{{ item.priceGears && item.priceGears.jkxl }}元/档</span>
            </div>
            <div class="item">
              <label>电缆线路：</label>
              <span>{{ item.priceGears && item.priceGears.dlxl }}元/米</span>
            </div>
            <div class="item">
              <label>单杆：</label>
              <span>{{ item.priceGears && item.priceGears.dgxl }}元/个</span>
            </div>
            <div class="" style="font-size: 14px; margin-left: 20px">
              标准档距：50米/档，现场勘查时不足50米按一档计；相关设备以及线路占地用户负责协调
            </div>
          </div>
        </div>

        <div class="intro-box" v-if="info.serviceType == 1">
          <span style="font-size: 20px"
            >预付油费
            <a style="color: red"
              >￥ {{ item.oilCost * 10 * form.days }}（{{
                item.oilCost
              }}/小时，每天按10小时计算）</a
            ></span
          >
        </div>

        <div class="num-list flex-row" v-if="info.serviceType == 0">
          <div class="item">
            <p>
              架空线路：<span
                >{{ item.priceGears && item.priceGears.jkxl }}元/档</span
              >
            </p>
            <el-input-number
              v-model="item.jkxl"
              @change="getSimTotal"
              :min="0"
              :max="100"
              label="描述文字"
            >
            </el-input-number>
          </div>
          <div class="item">
            <p>
              电缆线路：<span
                >{{ item.priceGears && item.priceGears.dlxl }}元/米</span
              >
            </p>
            <el-input-number
              v-model="item.dlxl"
              @change="getSimTotal"
              :min="0"
              :max="100"
              label="描述文字"
            >
            </el-input-number>
          </div>
          <div class="item">
            <p>
              单杆：<span
                >{{ item.priceGears && item.priceGears.dgxl }}元/个</span
              >
            </p>
            <el-input-number
              v-model="item.dgxl"
              @change="getSimTotal"
              :min="0"
              :max="1"
              label="描述文字"
            >
            </el-input-number>
          </div>
        </div>
      </div>
      <!-- 订单项 -->
      <div class="order">
        <div class="order-info flex-row">
          <div class="left">
              <div class="item address-box">
                  <p class="tit1">*工程名称</p>
                  <div class="address flex-row" style="margin-bottom: 70px">
                      <el-input v-model="projectname"
                                placeholder="请填写工程名称"
                      >

                      </el-input>
                  </div>
              </div>
            <p class="tit1">地址信息</p>
            <div class="address flex-row" style="margin-bottom: 70px;">
              <el-select
                v-model="addressVal"
                placeholder="请选择地址"
                size="medium"
              >
                <el-option
                  v-for="(item, index) in addressList"
                  :key="item.id"
                  :label="
                    item.provinceName +
                    '-' +
                    item.cityName +
                    '-' +
                    item.countyName +
                    ' ' +
                    item.address
                  "
                  :value="
                    item.provinceName +
                    item.cityName +
                    item.countyName +
                    item.address
                  "
                >
                </el-option>
              </el-select>
            </div>

              <p class="tit1">开始时间</p>
              <div class="address flex-row">
                  <!--                  <p>*：</p>-->
                  <el-date-picker class="datetime" v-model="form.startTime" value-format="yyyy-MM-dd" type="date"
                                  placeholder="选择日期">
                  </el-date-picker>

              </div>
              <p class="tips">*结束时间为次日开始时间的日期</p>

          </div>

          <div class="right" v-if="info.serviceType == 0">

            <p class="tit3">
              租赁期限<span
                >*不包含施工费用，最终价格需要厂商勘察现场后确认。</span
              >
            </p>
            <div class="term-list flex-row">
              <div
                :class="['item', { active: termNum == index }]"
                v-for="(item, index) in termList"
                @click="monthHandle(item, index)"
              >
                <p>{{ item.day }}月</p>
                <p>￥{{ item.price }}</p>
                <p>{{ item.priceStr }}</p>
                <em></em>
              </div>
            </div>
          </div>
          <div class="right"  v-else>
              <div class="item address-box">
                  <p class="tit1">服务天数</p>
                  <div class="address flex-row" style="margin-bottom: 70px">
                      <el-input placeholder="请输入天数" v-model="form.days" style="width: 100%;">
                          <template slot="prepend">时长</template>
                          <template slot="append">天</template>
                      </el-input>
                  </div>
              </div>
<!--              <div class="address flex-row">-->
<!--                  <p class="tit2">服务天数</p>-->
<!--                  <div class="address flex-row" style="padding-top: 15px;">-->
<!--                      <el-input placeholder="请输入天数" v-model="form.days" style="width: 100%;">-->
<!--                          <template slot="prepend">时长</template>-->
<!--                          <template slot="append">天</template>-->
<!--                      </el-input>-->
<!--                  </div>-->
<!--              </div>-->
<!--              <div class="item flex-row">-->
              <p class="tit1">开始时间</p>
              <div class="address flex-row">
<!--                  <p>*：</p>-->
                  <el-date-picker class="datetime" v-model="form.startTime" value-format="yyyy-MM-dd" type="date"
                                  placeholder="选择日期">
                  </el-date-picker>

              </div>
              <p class="tips">*结束时间为次日开始时间的日期</p>

<!--              <div class="item address-box">-->
<!--                  <p>*开始时间：</p>-->
<!--                  <el-date-picker class="datetime" v-model="form.startTime" value-format="yyyy-MM-dd" type="date"-->
<!--                                  placeholder="选择日期">-->
<!--                  </el-date-picker>-->
<!--                  <p class="tips">*结束时间为次日开始时间的日期</p>-->
<!--              </div>-->
<!--                  <div class="address flex-row">-->
<!--                      <p>*开始时间：</p>-->
<!--                      <el-date-picker class="datetime" v-model="form.startTime" value-format="yyyy-MM-dd" type="date"-->
<!--                                      placeholder="选择日期">-->
<!--                      </el-date-picker>-->
<!--                  </div>-->
<!--                  <p class="tips">*结束时间为次日开始时间的日期</p>-->
<!--              </div>-->
          </div>


        </div>
        <div class="bot flex-row">
          <p class="price">
            合计<span
              >￥{{
                info.serviceType == 0
                  ? form.advance + getSimTotal()
                  : form.advance + getOilTotalPrice()
              }}</span
            >
          </p>
          <button class="apply" @click="submit(1)" v-if="orderId == null">
            提交申请
          </button>
          <button class="saveOrder" @click="submit(0)" v-if="orderId == null">
            保存订单
          </button>
          <button class="saveOrder" @click="deleteOrder" v-if="orderId != null">
            中止订单
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RelatedCompany from "@/components/ordinary/relatedCompany.vue";
import {
  equipmentDetailApi,
  addOrderApi,
  adderssList,
  orderDetailApi,
  addCarOrder,
  eqPriceListApi,
} from "../../http/api/ordinary.js";
import { updateOrder, delOrder } from "../../http/factory/add-eme.js";
export default {
  components: {
    RelatedCompany,
  },
  data() {
    return {
      num: 1,
      activeNum: 0,
      termNum: 0,
        projectname:null,
      termList: [],
      num1: 0,
      num2: 0,
      num3: 0,
      date: "",
      info: {},
      form: {
        orderSatus: null,
        userAddress: "",
        startTime: null,
        orderType: 1,
        businessId: null,
        advance: 0,
        dgxlNum: 0,
        dgxlPrice: 0,
        jkxlNum: 0,
        jkxlPrice: 0,
        dlxlNum: 0,
        dlxlPrice: 0,
        //月份
        month: "",
        price: 0,
        days: 1,
      },
      addressList: [],
      addressVal: "",
      orderId: null,
      ids: [],
      eqList: [],
      sumBaodianPrice: 0,
      getPricFlag: true,
    };
  },
  created() {
    this.ids = this.$route.query.ids;
    this.getAddress();
    this.getDetail();
  },
  methods: {
    jisuanBaodianPrice() {
      this.form.advance = this.form.days * this.sumBaodianPrice;
    },
    getOilTotalPrice() {
      let total = 0;
      for (let item of this.eqList) {
        total += item.oilCost * 10 * this.form.days;
      }
      return total;
    },
    getEqPriceList() {
      if (this.info.serviceType == 0 && this.getPricFlag) {
        eqPriceListApi({
          equipmentIds: this.ids.join(","),
        }).then((res) => {
          this.termList = res;
          this.getPricFlag = false;
          this.form.advance = this.termList[this.termNum].price;
        });
      }
    },
    //删除订单
    deleteOrder() {

        this.$confirm("您确认要中止当前订单吗", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            updateOrder({
                id: this.orderId,
                orderSatus: 70,
                zzddTime: this.formatTime(),
            }).then((res) => {
                this.$message({
                    message: "中止成功",
                    type: "warning",
                    onClose: () => {
                        this.$router.back();
                    },
                });
            });
        });
      // delOrder({
      //   id: this.orderId,
      // }).then((res) => {
      //   this.$message({
      //     message: "取消成功",
      //     type: "warning",
      //     onClose: () => {
      //       this.$router.back();
      //     },
      //   });
      // });
    },
    getAddress() {
      adderssList({}).then((res) => {
        this.addressList = res.rows;
      });
    },
    customerServer() {
      this.$router.push({
        path: "/service",
      });
    },
    getDetail() {
      for (let id of this.ids) {
        equipmentDetailApi({
          id: id,
        }).then((res) => {
          //成套
          res["jkxl"] = 1;
          res["dlxl"] = 0;
          res["dgxl"] = 0;
          //保电...

          this.eqList.push(res);
          this.info = res;
          if (this.info.serviceType == 0) {
            this.getEqPriceList();
          } else {
            this.sumBaodianPrice += res.emergencyPrice;
            this.form.advance = this.sumBaodianPrice;
          }
        });
      }
    },

    submit(type) {
        if (this.projectname == null) {
            return this.$message("请输入项目名称");
        }
      if (this.form.startTime == null) {
        return this.$message("请选择开始时间");
      }
      this.$confirm(
        `您确认要${type == 1 ? "申请" : "保存"}当前订单吗`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.form.userAddress = this.addressVal;
          this.form.projectname = this.projectname;
        this.form.paymentVoucher = this.ids.join(",");
        this.form.businessId = this.eqList[0].customerId;
        this.form.orderSatus = type;
        this.form.advance =
          this.info.serviceType == 0
            ? this.form.advance + this.getSimTotal()
            : this.form.advance;
        if (this.info.serviceType == 0) {
          this.form.orderType = 0;
          this.form.orderPro = {
            duration: this.termList[this.termNum].day,
          };
          this.form.fuwuFangan = this.eqList;
        } else {
          this.form.advanceDate = this.form.days;
          this.form.orderType = 1;
          this.form.advanceFuel = this.getOilTotalPrice();
        }
        if(type==1){
            this.form.addTime=this.formatTime()
        }


        addCarOrder(this.form).then((res) => {
          this.$message({
            type: "success",
            message: "创建成功",
          });
          this.$router.push({
            path:
              this.info.serviceType == 0
                ? "/personalCenter/orderDevice"
                : "/personalCenter/orderPower",
          });
        });
      });
    },
    monthHandle(item, index) {
      this.termNum = index;
      if (this.info.serviceType == 0) {
        this.form.month = this.termList[this.termNum].day;
      }
      this.form.advance = this.termList[this.termNum].price;
    },

    getSimTotal() {
      let total = 0;
      for (let item of this.eqList) {
        total +=
          item.jkxl * item.priceGears.jkxl +
          item.dlxl * item.priceGears.dlxl +
          item.dgxl * item.priceGears.dgxl;
      }
      return total;
    },
  },
};
</script>

<style scoped lang="less">
.num-list {
  margin-top: 0.52rem;

  .item {
    width: 2.21rem;
    margin-right: 0.5rem;

    p {
      font-size: 0.14rem;
      color: #000000;

      span {
        color: #ff5050;
      }
    }

    .el-input-number {
      margin-top: 0.12rem;
      width: 2.21rem;
      height: 0.38rem;
      background: #fafafa;
      border-radius: 0.04rem;
      line-height: 0.38rem;

      /deep/.el-input-number__decrease {
        width: 0.59rem;
        height: 0.35rem;
        line-height: 0.35rem;
      }

      /deep/.el-input {
        height: 0.38rem;

        .el-input__inner {
          height: 0.38rem;
        }
      }
    }
  }
}

.content {
  font-size: 15px;

  .center {
    width: 78%;
    margin: 0 auto;
    padding: 20px 0;

    button {
      outline: none;
      cursor: pointer;
    }

    .header {
      background-color: #fff;
      padding: 20px;
      display: flex;
      justify-content: space-between;
      margin: 0px 0 15px;
      border-radius: 10px;
      align-items: center;
      font-size: 20px;
    }
  }

  .detail-box {
    margin-bottom: 20px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .device-box {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .device-img {
        width: 200px;
        height: 200px;
        border-radius: 10px;
        margin-right: 20px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .device-info {
        width: 30%;

        .name {
          font-size: 0.2rem;
          color: #333333;
          line-height: 0.23rem;
          font-weight: 500;
        }

        .price-box {
          margin-top: 0.22rem;
          font-size: 0.14rem;
          color: #000000;
          line-height: 0.2rem;
          align-items: center;
          position: relative;

          .price {
            color: #ff4141;
            margin-left: 0.1rem;
          }
        }

        .tips {
          font-size: 0.13rem;
          color: #8f8f8f;
          line-height: 0.33rem;
          margin-top: 0.1rem;
        }
      }

      .info {
        width: 60%;
        border: 1px solid #f2f2f2;

        .title {
          height: 40px;
          background: #fff3ec;
          line-height: 40px;
          padding-left: 10px;

          p {
            font-size: 20px;
            color: #000000;
          }
        }

        .info-intro {
          display: flex;
          flex-wrap: wrap;

          .item {
            margin: 30px 10px;
            width: 30%;
            font-size: 15px;

            label {
              color: #afafaf;
            }

            span {
              margin-left: 20px;
              color: #000000;
            }
          }
        }
      }

      .btns {
        flex: 1;
        text-align: right;
        padding-right: 0.22rem;

        .apply {
          width: 1.07rem;
          height: 0.42rem;
          background: #fa6600;
          border-radius: 0.06rem;
          font-size: 0.14rem;
          color: #ffffff;
          line-height: 0.42rem;
          text-align: center;
          border: none;
        }

        .service {
          width: 1.07rem;
          height: 0.42rem;
          background: #ffffff;
          border-radius: 0.06rem;
          border: 1px solid #fa6600;
          font-size: 0.14rem;
          color: #fa6600;
          line-height: 0.42rem;
          text-align: center;
          margin-top: 0.2rem;
        }
      }
    }

    .intro-box {
      margin-top: 20px;

      .title {
        font-size: 0.16rem;
        color: #000000;
      }

      .service-plan {
        margin-top: 20px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 20px;
        background: #f9f9f9;
        border-radius: 0.06rem;

        .item {
          line-height: 0;
          padding: 0.15rem 0.2rem;

          label {
            display: inline-block;
            min-width: 0.9rem;
            font-size: 0.14rem;
            line-height: 0.24rem;
            color: #aaaaaa;
            margin-right: 0.2rem;
            text-align: right;
          }

          span {
            font-size: 0.14rem;
            line-height: 0.24rem;
            color: #333333;
          }
        }
      }
    }
  }

  .order {
    margin-top: 0.1rem;
    background: #ffffff;
    border-radius: 0.06rem;
    padding: 0.3rem 0 0;

    .order-info {
      padding: 0 0.3rem;

      .left {
        margin-right: 1.52rem;

        .tit1 {
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;
        }

        .address {
          margin-top: 20px;

          .el-select {
            width: 300px;
          }
        }

        .tit2 {
          margin-top: 70px;
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;
        }

        .date {
          width: 300px;
          margin: 10px 0;
        }

        .tips {
          font-size: 0.13rem;
          color: #696969;
          margin-top: 0.1rem;
          line-height: 0.2rem;
        }
      }

      .right {
        .tit1 {
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;
        }
        .tit1 {
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;
        }

        .address {
          margin-top: 20px;

          .el-select {
            width: 300px;
          }
        }

        .tit2 {
          margin-top: 70px;
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;
        }

        .date {
          width: 300px;
          margin: 10px 0;
        }

        .tips {
          font-size: 0.13rem;
          color: #696969;
          margin-top: 0.1rem;
          line-height: 0.2rem;
        }
        .tit3 {
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;

          span {
            font-size: 0.13rem;
            color: #ff5050;
            margin-left: 0.11rem;
          }
        }

        .term-list {
          .item {
            margin-top: 0.25rem;
            min-width: 1.6rem;
            height: 0.8rem;
            background: #fafafa;
            border-radius: 0.04rem;
            border: 1px solid #e7e7e7;
            margin-right: 0.27rem;
            padding: 0.15rem 0.2rem;
            position: relative;
            overflow: hidden;
            cursor: pointer;

            p {
              font-size: 0.16rem;
              color: #b3b3b3;
              line-height: 0.22rem;
            }

            p:nth-of-type(2) {
              font-size: 0.14rem;
              margin: 0.08rem 0;
              line-height: 0.2rem;
            }

            &.active {
              background: #fff5ef;
              border: 1px solid #fec4a2;

              p {
                color: #ff8e4f;
              }

              em {
                display: block;
                position: absolute;
                right: -0.24rem;
                bottom: -0.24rem;

                &:before {
                  content: "";
                  width: 0.48rem;
                  height: 0.48rem;
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  background-color: #ff8e4f;
                  border-radius: 50%;
                }

                &:after {
                  content: "";
                  width: 0.05rem;
                  height: 0.1rem;
                  position: absolute;
                  left: -0.36rem;
                  bottom: 0.3rem;
                  border: 1px solid #fff;
                  border-top-color: transparent;
                  border-left-color: transparent;
                  transform: rotate(45deg);
                  z-index: 10;
                }
              }
            }
          }
        }

        .num-list {
          margin-top: 0.52rem;

          .item {
            width: 2.21rem;
            margin-right: 0.5rem;

            p {
              font-size: 0.14rem;
              color: #000000;

              span {
                color: #ff5050;
              }
            }

            .el-input-number {
              margin-top: 0.12rem;
              width: 2.21rem;
              height: 0.38rem;
              background: #fafafa;
              border-radius: 0.04rem;
              line-height: 0.38rem;

              /deep/.el-input-number__decrease {
                width: 0.59rem;
                height: 0.35rem;
                line-height: 0.35rem;
              }

              /deep/.el-input {
                height: 0.38rem;

                .el-input__inner {
                  height: 0.38rem;
                }
              }
            }
          }
        }
      }
    }

    .bot {
      margin-top: 0.4rem;
      width: calc(100% - 0.6rem);
      padding: 0.22rem 0.3rem 0.17rem;
      border-top: 1px solid #ededed;
      justify-content: flex-end;

      .price {
        font-size: 0.14rem;
        color: #757575;
        line-height: 0.4rem;

        span {
          font-size: 0.24rem;
          color: #ff4a4a;
          margin-left: 0.1rem;
        }
      }

      .apply {
        width: 1.38rem;
        height: 0.4rem;
        background: #686868;
        border: 1px solid #686868;
        border-radius: 0.09rem;
        font-size: 0.14rem;
        color: #ffffff;
        line-height: 0.4rem;
        text-align: center;
        margin-left: 0.35rem;
      }

      .saveOrder {
        width: 1.38rem;
        height: 0.4rem;
        border: 1px solid #686868;
        border-radius: 0.09rem;
        font-size: 0.14rem;
        color: #686868;
        line-height: 0.4rem;
        text-align: center;
        margin-left: 0.32rem;
      }
    }
  }
}
</style>
